module.exports = __webpack_public_path__ + "static/media/logo-white.e59b3ac9.svg";